import { render, staticRenderFns } from "./fb.vue?vue&type=template&id=89027672&scoped=true"
import script from "./fb.vue?vue&type=script&lang=js"
export * from "./fb.vue?vue&type=script&lang=js"
import style0 from "./fb.vue?vue&type=style&index=0&id=89027672&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89027672",
  null
  
)

export default component.exports